import { put, delay, takeLatest, select } from 'redux-saga/effects';
import querystring from 'qs';
import { userActions as actions } from '.';
import { UserPayload, UserType } from './types';
import {
  selectErpSystem,
  selectLanguageId,
} from '../../erpSystem/slice/selectors';
import { TARGET_SYSTEM } from '../../../../constants';

export function* fetchUser() {
  const erpSystem = yield select(selectErpSystem);
  const languageId = yield select(selectLanguageId);
  const payload: UserPayload = {
    erpSystem,
    languageId,
    targetSystem: TARGET_SYSTEM,
  };
  const { getUserSuccess, getUserError } = actions;
  do {
    try {
      const userResponse = yield fetch(
        `/gasket-configurator/api/user?${querystring.stringify(payload)}`,
      );
      if (userResponse.status !== 200) {
        yield put(getUserError('failed to fetch'));
      } else {
        const user: UserType = yield userResponse.json();
        yield put(getUserSuccess(user));
      }
      // we are fetching user every hour
      yield delay(3600 * 1000);
    } catch (e: any) {
      yield put(getUserError('failed to fetch'));
    }
  } while (true);
}

export function* userSaga() {
  yield takeLatest(actions.getUser.type, fetchUser);
}
